import { render, staticRenderFns } from "./ModalAddress.vue?vue&type=template&id=6affd12e&"
import script from "./ModalAddress.vue?vue&type=script&lang=js&"
export * from "./ModalAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports